import { difference, lineIntersect, lineOffset, lineOverlap, lineString, lineToPolygon, multiPolygon, polygon, Position } from "@turf/turf";

export function splitPolygon(basePolygon: number[][] | Position[], line: number[][], direction: number, id: 'upper' | 'lower') {

    let j;
    let polyCoords = [];
    let cutPolyGeoms = [];
    let retVal = null;

    const turfBasePolygon = polygon([basePolygon])

    const latLngLineString = line.map(point => [point[1], point[0]])

    const turfLineString = lineString(latLngLineString)
    let intersectPoints = lineIntersect(turfBasePolygon, turfLineString);

    var nPoints = intersectPoints.features.length;
    
    if ((nPoints === 0) || ((nPoints % 2) !== 0)) return retVal;
    
    var offsetLine = lineOffset(turfLineString, (0.02 * direction), { units: 'kilometers' });
    
    for (j = 0; j < turfLineString.geometry.coordinates.length; j++) {
        polyCoords.push(turfLineString.geometry.coordinates[j]);
    }

    for (j = (offsetLine.geometry.coordinates.length - 1); j >= 0; j--) {
        polyCoords.push(offsetLine.geometry.coordinates[j]);
    }

    polyCoords.push(turfLineString.geometry.coordinates[0]);

    let thickLineString = lineString(polyCoords);
    let thickLinePolygon = lineToPolygon(thickLineString);

    let clipped = difference(turfBasePolygon, thickLinePolygon);
    for (j = 0; j < clipped!.geometry.coordinates.length; j++) {
        // @ts-ignore
        var polyg = polygon(clipped!.geometry.coordinates[j]);
        var overlap = lineOverlap(polyg, turfLineString, { tolerance: 0.005 });
        if (overlap.features.length > 0) {
            cutPolyGeoms.push(polyg.geometry.coordinates);
        }
    }

    if (cutPolyGeoms.length === 1) {
        retVal = polygon(cutPolyGeoms[0], { id: id });
    } else if (cutPolyGeoms.length > 1) {
        retVal = multiPolygon(cutPolyGeoms, { id: id });
    }

    return retVal;
}